import { createSlice } from '@reduxjs/toolkit';

import { UnitRatesState } from '../types';

export const initialUnitRatesState: UnitRatesState = {};

const unitRatesSlice = createSlice({
  name: 'unitRates',
  initialState: initialUnitRatesState,
  reducers: {
    setUnitRates: (state, action) => {
      Object.assign(state, {
        ...action.payload,
      });
    },
    unitRatesMutationComplete(state, action) {
      const { payload } = action;
      const { status } = payload;

      if (state.syncState) {
        Object.assign(state.syncState, { status });

        if (status === 'success') {
          Object.assign(state.syncState, { serverRevision: payload.serverRevision });
        }
      }
    },
  },
});

export const { setUnitRates, unitRatesMutationComplete } = unitRatesSlice.actions;
export const unitRatesReducer = unitRatesSlice.reducer;
